import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-wrapper auth" }
const _hoisted_2 = { class: "page-inner bg-brand-gradient" }
const _hoisted_3 = { class: "page-content-wrapper bg-transparent m-0" }
const _hoisted_4 = {
  class: "flex-1",
  style: {"background":"url(img/svg/pattern-1.svg) no-repeat center bottom fixed","background-size":"cover"}
}
const _hoisted_5 = { class: "container py-4 py-lg-5 my-lg-5 px-4 px-sm-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-12 col-md-6 col-lg-5 col-xl-4 ml-auto" }
const _hoisted_8 = { class: "card p-4 rounded-plus bg-faded" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "row no-gutters" }
const _hoisted_12 = { class: "col-lg-12 pr-lg-1 my-2" }
const _hoisted_13 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"height-10 w-100 shadow-lg px-4 bg-brand-gradient\" data-v-441cf5df><div class=\"d-flex align-items-center container p-0\" data-v-441cf5df><div class=\"page-logo width-mobile-auto m-0 align-items-center justify-content-center p-0 bg-transparent bg-img-none shadow-0 height-9 border-0\" data-v-441cf5df><a href=\"javascript:void(0)\" class=\"page-logo-link press-scale-down d-flex align-items-center\" data-v-441cf5df><img src=\"img/logo.png\" aria-roledescription=\"logo\" data-v-441cf5df><span class=\"page-logo-text mr-1\" style=\"color:#073190;\" data-v-441cf5df>業務管理システム</span></a></div></div></div>", 1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col col-md-6 col-lg-7 hidden-sm-down" }, [
                  _createElementVNode("img", {
                    src: "img/mainlogo.png",
                    alt: "メインロゴ",
                    style: {"width":"90%"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", {
                      class: "loader",
                      id: "loaderLgin",
                      style: {"text-align":"center"}
                    }, [
                      _createElementVNode("i", {
                        style: {"margin-top":"90px"},
                        class: "fal fa-spinner-third fa-spin-4x fs-xxl"
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[4] || (_cache[4] = _createElementVNode("label", {
                        class: "form-label",
                        for: "username"
                      }, "ログインID", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "username",
                        class: "form-control form-control-lg",
                        placeholder: "ログインID",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginid) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.loginid]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", {
                        class: "form-label",
                        for: "password"
                      }, "パスワード", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        id: "password",
                        class: "form-control form-control-lg",
                        placeholder: "password",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginpass) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.loginpass]
                      ])
                    ]),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "spacer-login" }, null, -1)),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "btn btn-info btn-block btn-lg",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.login()))
                        }, " ログイン ")
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "position-absolute pos-bottom pos-left pos-right p-3 text-center text-white" }, [
                _createElementVNode("i", null, [
                  _createElementVNode("strong", null, "System Message:ver 20261006042948")
                ]),
                _createTextVNode("    2026  "),
                _createElementVNode("a", {
                  href: "https://fusion-outdoor.co.jp/",
                  class: "text-white opacity-40 fw-500",
                  title: "https://fusion-outdoor.co.jp/",
                  target: "_blank"
                }, "https://fusion-outdoor.co.jp/")
              ], -1))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal" }, {
      title: _withCtx(() => [
        _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4Modal), 1)
      ]),
      body: _withCtx(() => _cache[12] || (_cache[12] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 閉じる ")
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}